var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 179,
    viewBox: "0 0 251 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_753_31423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 69.9287C25.8907 77.9273 45.8226 71.4428 54.0179 55.4495C62.2133 39.4522 55.5693 19.9986 39.1827 12L9.5 69.9287Z",
    stroke: "#DDE2E5",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3914 153.727C43.4757 153.727 46.7867 150.495 46.7867 146.509C46.7867 142.523 43.4757 139.291 39.3914 139.291C35.3071 139.291 31.9961 142.523 31.9961 146.509C31.9961 150.495 35.3071 153.727 39.3914 153.727Z",
    stroke: "#DDE2E5",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.063 147.865C193.056 142.585 189.386 131.421 193.559 122.006C196.282 115.865 201.609 111.73 207.662 110.185C211.29 109.391 214.432 107.031 216.252 103.545C217.314 101.511 217.776 99.3427 217.671 97.213C217.536 94.9483 218.023 92.6191 219.221 90.4654C222.391 84.7687 229.642 82.3252 235.734 84.9144L236.262 85.1772C241.988 88.4656 244.224 95.6279 241.365 101.479C240.285 103.687 238.64 105.44 236.682 106.668C234.857 107.834 233.329 109.476 232.267 111.51C230.447 114.996 230.337 118.865 231.811 122.196C234.087 127.884 233.794 134.522 230.3 140.28C224.947 149.108 213.536 152.771 203.865 148.761L202.067 147.867L202.063 147.865Z",
    stroke: "#DDE2E5",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.524 22.4064C186.524 9.94466 196.871 -0.154709 209.64 -0.154709C222.408 -0.154709 232.755 9.94466 232.755 22.4064C232.755 34.8681 222.408 44.9674 209.64 44.9674H186.524V22.4064Z",
    fill: "#DDE2E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4248 122.638C38.4865 115.241 28.3418 113.157 20.7679 117.972C13.1898 122.792 11.0537 132.693 15.9879 140.086L43.4248 122.634L43.4248 122.638Z",
    fill: "#DDE2E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7834 152.127C66.7834 150.258 68.2985 148.743 70.1675 148.743H93.6811H120.579H147.476H170.99C172.859 148.743 174.374 150.258 174.374 152.127V159.79V167.453C174.374 169.322 172.859 170.837 170.99 170.837H147.476H120.579H93.6811H70.1675C68.2985 170.837 66.7834 169.322 66.7834 167.453V159.79V152.127Z",
    fill: "#B5C8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.874 150.205V167.453C172.874 168.494 172.03 169.337 170.99 169.337H147.476H120.579H93.6811H70.1675C69.127 169.337 68.2834 168.494 68.2834 167.453V160.03V150.205C68.2834 149.145 69.1129 148.321 70.1341 148.321H170.998C172.034 148.321 172.874 149.16 172.874 150.205Z",
    stroke: "#003FEE",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0525 159.464H154.466",
    stroke: "#003FEE",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7834 124.269C66.7834 122.4 68.2985 120.885 70.1675 120.885H93.6811H120.579H147.476H170.99C172.859 120.885 174.374 122.4 174.374 124.269V131.932V139.595C174.374 141.464 172.859 142.979 170.99 142.979H147.476H120.579H93.6811H70.1675C68.2985 142.979 66.7834 141.464 66.7834 139.595V131.932V124.269Z",
    fill: "#B5C8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.874 122.347V139.595C172.874 140.636 172.03 141.479 170.99 141.479H147.476H120.579H93.6811H70.1675C69.127 141.479 68.2834 140.636 68.2834 139.595V132.172V122.347C68.2834 121.287 69.1129 120.463 70.1341 120.463H170.998C172.034 120.463 172.874 121.302 172.874 122.347Z",
    stroke: "#003FEE",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0525 131.606H154.466",
    stroke: "#003FEE",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1165 20.2975V59.6731V108.374C69.1165 110.664 70.9721 112.519 73.2613 112.519H168.592C170.881 112.519 172.736 110.664 172.736 108.374V59.6731V10.9717C172.736 8.68258 170.881 6.82689 168.592 6.82689L70.1527 6.82689",
    stroke: "#003FEE",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3213 77.9299H151.21",
    stroke: "#003FEE",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3213 89.6957H127.678",
    stroke: "#003FEE",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.153 6.8269L65.2956 6.82669L62.0131 6.82672C59.1442 6.82674 57.8066 10.3816 59.9639 12.2728L69.1168 20.2969",
    stroke: "#003FEE",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.4062,
    y: 15.1161,
    width: 87.0408,
    height: 51.81,
    rx: 4.47638,
    fill: "#B5C8FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_753_31423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 178.677,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/empty-state.3f6c0f0053904f8fea83417461159ffb.svg";
export { ForwardRef as ReactComponent };